import _ from 'lodash';
import { Record as record, List, Map } from 'immutable';

import { translate as t } from '../../lib/I18n';
import { toImmutable } from '../../helpers/Immutable';
import { resolve, resolveAll } from '../../helpers/LinkMapper';
import { SeatingPrefs, SeatingPrefNames, COUNTED_PLACE } from '../../constants/AppConstants';


const defaults = {
    seat: null,
    coach: null,
    attributes: new List(),
    supplement: new Map()
};


class Seat extends record(defaults) {

    static fromJSON (json = {}) {
        return new Seat({
            seat: resolve(json.seat).with(String),
            coach: resolve(json.coach).with(String),
            attributes: resolveAll(json.attributes).with(String),
            supplement: resolve(json.supplement).with(toImmutable)
        });
    }

    getCoach () {
        return this.coach;
    }

    getSeat () {
        return this.seat;
    }

    getAttributeNames () {
        return this.attributes
            // We want to only display the seat attributes we know about
            .filter((attribute) => _.values(SeatingPrefs).includes(attribute))
            .map((attribute) => t(SeatingPrefNames[attribute]));
    }

    isCountedPlace () {
        return _.some([
            this.getCoach() === COUNTED_PLACE,
            this.getSeat() === COUNTED_PLACE
        ]);
    }

}


export default Seat;



// WEBPACK FOOTER //
// ./src/records/order/Seat.js